import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.52 7h-12.52l4 5l-4 5h12.52a1 1 0 0 0 .78 -.375l3.7 -4.625l-3.7 -4.625a1 1 0 0 0 -.78 -.375","key":"svg-0"}]]

const IconLabelImportant = createReactComponent('outline', 'label-important', 'LabelImportant', __iconNode);

export default IconLabelImportant;